module.exports = __webpack_public_path__ + "img/14.79c8619a.jpg";